/**
 * RestRelativeBinding behavior — how the animation binder applies bound
 * rotations to named nodes of this object's instance.
 *
 * Inert at runtime: `loaders/animationBinding/bindAnimationSources` reads its
 * data when it binds the object's sources and transforms the bound rotation
 * keys once, at bind time (left-multiplying by a constant rest rotation
 * commutes with slerp), so there is no per-frame pass. A commit re-binds.
 */

import { TraceBehavior } from "./tracebehavior";
import type { RestRelativeBindingData } from "../scenedata/behaviors/restrelativebindingdata";
import { bindAnimationSources } from "../loaders/animationBinding/bindAnimationSources";

export class RestRelativeBinding extends TraceBehavior<RestRelativeBindingData> {
    static readonly behaviorType = "RestRelativeBinding" as const;

    protected override async applyCommit(): Promise<void> {
        if (this.sceneObject.animationBinding?.sources?.length) await bindAnimationSources(this.sceneObject);
    }
}
